// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2xDjL","empty":"ModalGraph_empty__1Klhh"};